import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Link, NavLink } from "react-router-dom";
import { Context } from "../../context";
import VisibilitySensor from "react-visibility-sensor";
import classes from "./Demo.module.css";

const DemoBreadcrumb = ({ title }) => {
  const { debug, lang } = useContext(Context);
  
  return (
    <>
      <p className={classes.breadcrumb}>
        <NavLink to="/demo" className="nav-link smooth-scroll text-underline">
          <button className={`${classes.allDemoButton} btn btn-sm`}>
            All demo
            {lang === "en" && <></>}
                    {lang === "it" && <></>}
          </button>
        </NavLink>
        &nbsp; &gt; {title}
      </p>
    </>
  );
};

export default DemoBreadcrumb;
